<template>
  <div id="contents">
    <div class="recruit_corona" >
      <div class="recruit_corona_main move_view">
        <div class="title_area">
          <p class="title">コロナ対策</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" />
        </div>
        <p class="caption">コロナウイルス感染が拡大し、先行きが見えない時代だからこそ、世の中に真に「面白い」コンテンツを届けたい。そのためには、社員が安心できる環境づくりが大切です。感染対策、在宅勤務の取り組みをご紹介します。</p>
      </div>
      <div id="recruit_corona_section0" class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/01.png" alt="01" width="54"></p>
        </div>
        <div class="c_counter counter_01">
          <p class="title">新入社員のスタートもコロナ対策モードで</p>
          <ul class="list">
            <li><p>4月いっぱいは自宅でオンライン研修。</p></li>
            <li><p>入社式は5月に本社の外にて。フィジカルディスタンス入社式として実施しました！</p></li>
          </ul>
          <ul class="img_list">
            <li><p><img src="../assets/img/common/recruit_2022/corona/counter_01.png" alt="コロナ対策" width="410" /></p></li>
            <li><p><img src="../assets/img/common/recruit_2022/corona/counter_02.png" alt="コロナ対策" width="410" /></p></li>
          </ul>
        </div>
      </div>
      <div id="recruit_corona_section1" class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/02.png" alt="02" width="53"></p>
        </div>
        <div class="c_counter counter_02">
          <p class="title">オフィスではこんな感染対策を</p>
          <div class="flex">
            <ul class="list">
              <li><p>スタッフの体調管理を毎日行っています。</p></li>
              <li><p>本社ではフリーアドレス制を採用。仕事場所を自由に選べるので、フィジカルディスタンスが保たれています。会社全体で300枚以上の飛沫防止パネルを設置。</p></li>
              <li><p>出社率を抑え、可能な限り在宅勤務をするよう推奨しています。</p></li>
            </ul>
            <p><img src="../assets/img/common/recruit_2022/corona/office_01.png" alt="コロナ対策" width="272" /></p>
          </div>
          <ul class="img_list">
            <li><p><img src="../assets/img/common/recruit_2022/corona/office_02.png" alt="コロナ対策" width="410" /></p></li>
            <li><p><img src="../assets/img/common/recruit_2022/corona/office_03.png" alt="コロナ対策" width="410" /></p></li>
          </ul>
          <div class="c_new_employee">
            <p class="name">伊藤瑶二朗（2020年入社）</p>
            <p class="img"><img src="../assets/img/common/recruit_2022/corona/employee_01.png" alt="社内行事もLIVE配信しました。" width="261" /></p>
          </div>
        </div>
      </div>
      <div id="recruit_corona_section2" class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/03.png" alt="03" width="54"></p>
        </div>
        <div class="c_counter counter_03">
          <p class="title">業務オンライン化への取り組み</p>
          <p class="caption">これまで、番組制作現場では「在宅勤務なんて、できるの？」と誰もが思っていましたが、やればできるんです。</p>
          <ul class="list">
            <li><p>全従業員にスマートフォンを支給。連絡ツールに LINE WORKSを導入し、迅速な社内連絡に活用しています。</p></li>
            <li><p>フリーアドレス制に伴い、ノートPCを配布。会議は原則オンライン化しました。</p></li>
            <li><p>若手の研修もオンライン化（業界トップクリエイターを招いての講演もLIVE配信）。</p></li>
          </ul>
          <ul class="img_list">
            <li><p><img src="../assets/img/common/recruit_2022/corona/online_01.png" alt="コロナ対策" width="410" /></p></li>
            <li><p><img src="../assets/img/common/recruit_2022/corona/online_02.png" alt="コロナ対策" width="410" /></p></li>
          </ul>
          <div class="c_new_employee">
            <p class="name">山本翼（2020年入社）</p>
            <p class="img"><img src="../assets/img/common/recruit_2022/corona/employee_02.png" alt="「徹子の部屋」の黒柳さんとの打ち合わせもオンラインで行っています。" width="297" /></p>
          </div>
        </div>
      </div>
      <div id="recruit_corona_section3" class="recruit_corona_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2022/corona/04.png" alt="04" width="55"></p>
        </div>
        <div class="c_counter counter_04">
          <p class="title">「出社しない番組制作」の発想力</p>
          <p class="caption">若林社長の「想定外のことが起こったときが、クリエイティブな仕事をする人にとってチャンスなんだ」という言葉のとおり、制作現場ではさまざまな工夫をして、真に「面白い」コンテンツをカタチにしています。</p>
          <div class="c_imagination imagination_01">
            <div class="desc">
              <p>「じゅん散歩」では、いち早くフェースガードを導入。出演者につけてもらって散歩をするように。散歩のスタイルを変え、リモート取材・ガイドを導入し、スタッフの人数を減らし…と番組づくりも状況に応じて変えています。</p>
            </div>
            <div class="imagination_img_wrap">
              <p class="program_img"><img src="../assets/img/common/recruit_2022/corona/imagination_01.png" alt="じゅん散歩" width="388"></p>
              <div class="director">
                <p><img src="../assets/img/common/recruit_2022/corona/director_01.png" alt="林プロデューサー"  width="340"></p>
                <p class="name">林プロデューサー</p>
              </div>
            </div>
          </div>
          <div class="c_imagination imagination_02">
            <div class="desc">
              <p>ローランド公式YouTube「THE ROLAND SHOW」は、ロケ以外をすべて在宅で制作。ナレーション録りでは、マイクをナレーターさん宅に送って収録。編集も配信も各ディレクターが自宅で行っています。</p>
            </div>
            <div class="imagination_img_wrap">
              <p class="program_img"><img src="../assets/img/common/recruit_2022/corona/imagination_02.png" alt="THE ROLAND SHOW" width="388"></p>
              <div class="director">
                <p><img src="../assets/img/common/recruit_2022/corona/director_02.png" alt="宋ディレクター" width="357"></p>
                <p class="name">宋ディレクター</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_corona',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'info_layout_status',
    'request_tag_id'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    // //animation
    // this.$nextTick(() => {
    //   var secTopArr = new Array();
    //   var current = -1;
    //   $('.recruit_corona_list').each(function (i) {
    //     secTopArr[i] = $(this).offset().top;
    //   });
    //   $(window).scroll(function () {
    //     for (var i = secTopArr.length-1; i>=0; i--) {
    //       if ($(window).scrollTop() > secTopArr[i] - 450) {
    //         if (i != current) {
    //           $('#recruit_corona_section'+i).addClass('move_view');
    //           current = i;
    //           break;
    //         }
    //       }
    //     }
    //   });
    // });

  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_corona
    .title
      position: relative
      // overflow: hidden
      // opacity: 0
      display: inline-block
      // &::before
      //   content: ""
      //   display: block
      //   position: absolute
      //   background: #fff
      //   top: 0
      //   left: -10%
      //   width: 120%
      //   height: 100%
      //   z-index: 50
      //   -webkit-transform: skewX(10deg)
      //   transform: skewX(10deg)
    .text
      position: relative
      // overflow: hidden
      // opacity: 0
      display: inline-block
      &::before
        content: ""
        display: block
        position: absolute
        background: #fff
        top: 0
        left: -10%
        width: 120%
        height: 100%
        z-index: 50
        -webkit-transform: skewX(10deg)
        transform: skewX(10deg)
    &_main
      width: 1000px
      margin: 0 auto
      margin-top: 155px
      padding-bottom: 48px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -44px
        left: 67px
      .title
        @include recruit_font(41px, 79px, 0.176em)
        color: #fff
        background: #64BC24
        padding: 0 14px 0 5px
        display: table
      .close_icon
        position: absolute
        right: 0px
        top: -62px
        img
          width: 40px
          height: 40px
      a
        color: #000
        text-decoration: none
      .caption
        @include recruit_font(16px, 28px, 3px)
        margin-top: 88px
        padding: 0 66px 0 66px
        height: 52px
        display: inline-block
    &_list
      width: 1000px
      margin: 0 auto
      margin-top: 20px
      background-color: #fff
      position: relative
      &:last-child
        margin-top: 19px
        margin-bottom: 163px
      .number_area
        position: absolute
        top: 45px
        left: -30px
        display: flex
        align-items: center
        height: 66px
        background: #64BC24
      .number
        padding: 0 14px 0 84px
        display: block
        // overflow: hidden
        // opacity: 0
        img
        // &::before
        //   content: ""
        //   display: block
        //   position: absolute
        //   background: #fff
        //   top: 0
        //   left: -10%
        //   width: 120%
        //   height: 100%
        //   z-index: 50
        //   -webkit-transform: skewX(10deg)
        //   transform: skewX(10deg)
      .c_counter
        position: relative
        padding: 56px 82px 70px 74px
        .title
          @include recruit_font(28px, 42px, 4px)
          margin: 0 0 51px 74px
        .caption
          @include recruit_font(16px, 1.75em, 0.14em)
          margin: 0 0 37px
        .flex
          display: flex
          justify-content: space-between
        .list
          li
            display: flex
            margin-bottom: 16px
            padding: 0 34px 0 0
            &::before
              content: ""
              width: 16px
              height: 16px
              margin: 3px 0 0
              border-radius: 100%
              background: #64BC24
            &:last-child
              margin-bottom: 0px
            p
              @include recruit_font(14px, 1.7em, 0.14em)
              width: 100%
              padding-left: 14px
          img
            width: 100%
        .img_list
          display: flex
          justify-content: space-between
          margin: 53px 0 0
      .counter_02
        padding: 56px 82px 82px 74px
        .title
          margin: 0 0 44px 74px
        .list
          margin: 7px 0 0
        .img_list
          margin: 71px 0 0
        .c_new_employee
          right: -81px
          .name
            margin: 0 -2px 10px 0
      .counter_03
        padding: 56px 82px 104px 74px
        .list
          li
            padding: 0
        .c_new_employee
          right: -115px
      .counter_04
        padding: 56px 66px 70px 74px
      .c_new_employee
        position: absolute
        right: 0px
        bottom: 0px
        display: inline-flex
        align-items: flex-end
        .name
          @include recruit_font(11px, 1em, 0.14em)
          margin: 0 -6px 10px 0
          color: #64BC24
        .img
      .c_imagination
        margin: 50px 0 0
        &:first-child
          margin: 0
        .desc
          display: flex
          margin-bottom: 35px
          &::before
            content: ""
            width: 16px
            height: 16px
            margin: 3px 0 0
            border-radius: 100%
            background: #64BC24
          p
            width: 100%
            padding-left: 14px
            @include recruit_font(14px, 1.7em, 0.14em)
            &:last-child
              margin-bottom: 0px
        .imagination_img_wrap
          display: flex
          justify-content: space-between
          padding: 0 0 0 33px
          .director
            .name
              @include recruit_font(11px, 1em, 0.14em)
              color: #64BC24
              text-align: right
      .imagination_01
        .director
          padding: 0 30px 0 0
          .name
            margin: 12px 21px 0 0
      .imagination_02
        .director
          padding: 0 25px 0 0
          .name
            margin: 12px 45px 0 0

  // .move_view
  //   .title
  //     opacity: 1
  //     &::before
  //       -webkit-animation: fadein0 1.8s 1 ease forwards
  //       animation: fadein0 1.8s 1 ease forwards
  //     @keyframes fadein0
  //       0%
  //         width: 150%
  //         left: -12.5%
  //         opacity: 1
  //       60%
  //         width: 150%
  //         left: 150%
  //         opacity: 1
  //       100%
  //         width: 150%
  //         left: 150%
  //         opacity: 0
  //   .text
  //     opacity: 1
  //     &::before
  //       -webkit-animation: textfadein0 1.8s 1 ease forwards
  //       animation: textfadein0 1.8s 1 ease forwards
  //     @keyframes textfadein0
  //       0%
  //         width: 150%
  //         left: -12.5%
  //         opacity: 1
  //       60%
  //         width: 150%
  //         left: 150%
  //         opacity: 1
  //       100%
  //         width: 150%
  //         left: 150%
  //         opacity: 0
  //   .number
  //     opacity: 1
  //     &::before
  //       -webkit-animation: fadein1 1.8s 1 ease forwards
  //       animation: fadein1 1.8s 1 ease forwards

  //     @keyframes fadein1
  //       0%
  //         width: 150%
  //         left: -12.5%
  //         opacity: 1
  //       60%
  //         width: 150%
  //         left: 150%
  //         opacity: 1
  //       100%
  //         width: 150%
  //         left: 150%
  //         opacity: 0
</style>



// WEBPACK FOOTER //
// src/components/recruit_corona.vue